import { Aggregation } from './aggregation';
import { DateRange } from './dateRange';
import { Filter } from './filter';
import { GeoFilter } from './geoFilter';

export class SearchInput {
  queryFilters?: Array<Filter>;
  geoQueryFilters?: Array<GeoFilter>;
  aggregation?: Aggregation;
  dateRange?: DateRange;
  fieldsPattern?: Array<string>;
  existFields?: Array<string>;
  sortByList?: Array<any>;
  constructor() {
    this.queryFilters = null;
    this.geoQueryFilters = null;
    this.aggregation = null;
    this.dateRange = null;
    this.fieldsPattern = null;
    this.existFields = null;
    this.sortByList = null;
  }
}
